/*
 * NUHO Product Page — Selling Plan Interceptor
 *
 * Instead of fighting Appstle for click handlers,
 * we intercept fetch() itself. When ANY code calls /cart/add.js
 * for our product without a selling_plan, we inject it.
 *
 * This works regardless of who triggers the add-to-cart.
 */
(function() {
  if (!window.location.pathname.includes('/products/')) return;

  var KNOWN_VARIANT = 56178029953410;
  var currentPlan = null; // selling plan id of the selected card (null = one-time)

  function readPlan(el){ var pid = el && el.getAttribute('data-plan-id'); return pid ? parseInt(pid, 10) : null; }
  function syncPlan(){ var a = document.querySelector('.pdp__opt--active'); if (a) currentPlan = readPlan(a); }

  // Event delegation on document — the selected card's data-plan-id is the source of truth
  document.addEventListener('click', function(e) {
    var opt = e.target.closest('[data-opt]');
    if (opt) { currentPlan = readPlan(opt); }
    else { setTimeout(syncPlan, 30); }
    console.log('NUHO: currentPlan =', currentPlan);
  });
  document.addEventListener('DOMContentLoaded', syncPlan);
  window.addEventListener('load', syncPlan);
  setTimeout(syncPlan, 1200);

  // Monkey-patch fetch to intercept /cart/add.js
  var originalFetch = window.fetch;
  window.fetch = function(url, options) {
    if (typeof url === 'string' && url.indexOf('/cart/add') !== -1 && options && options.body) {
      try {
        var body = JSON.parse(options.body);
        if (body.items && Array.isArray(body.items)) {
          var modified = false;
          body.items.forEach(function(item) {
            if (item.id === KNOWN_VARIANT && !item.selling_plan && currentPlan) {
              item.selling_plan = currentPlan;
              modified = true;
            }
          });
          if (modified) {
            console.log('NUHO: injected selling_plan into cart/add request', body);
            options = Object.assign({}, options, {
              body: JSON.stringify(body)
            });
          }
        }
      } catch(e) {
        // Not JSON, probably FormData — try that too
      }
    }

    // Also intercept FormData-based requests
    if (typeof url === 'string' && url.indexOf('/cart/add') !== -1 && options && options.body instanceof FormData) {
      var fd = options.body;
      var variantId = parseInt(fd.get('id'), 10);
      var currentSp = fd.get('selling_plan');
      if (variantId === KNOWN_VARIANT && (!currentSp || currentSp === '' || currentSp === '0') && currentPlan) {
        fd.set('selling_plan', String(currentPlan));
        console.log('NUHO: injected selling_plan into FormData request');
      }
    }

    return originalFetch.call(this, url, options);
  };

  // Also monkey-patch XMLHttpRequest for older code paths
  var origXHROpen = XMLHttpRequest.prototype.open;
  var origXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url) {
    this._nuhoUrl = url;
    return origXHROpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function(body) {
    if (this._nuhoUrl && this._nuhoUrl.indexOf('/cart/add') !== -1 && typeof body === 'string') {
      try {
        var data = JSON.parse(body);
        if (data.id === KNOWN_VARIANT && !data.selling_plan && currentPlan) {
          data.selling_plan = currentPlan;
          body = JSON.stringify(data);
          console.log('NUHO: injected selling_plan into XHR request');
        }
        if (data.items) {
          data.items.forEach(function(item) {
            if (item.id === KNOWN_VARIANT && !item.selling_plan && currentPlan) {
              item.selling_plan = currentPlan;
              console.log('NUHO: injected selling_plan into XHR items request');
            }
          });
          body = JSON.stringify(data);
        }
      } catch(e) {}
    }
    return origXHRSend.call(this, body);
  };

  console.log('NUHO: selling plan interceptor loaded v2 (event delegation, fixes incognito race)');
})();

/* NUHO-OFFER-PRESELECT v3 : ad/Meta traffic -> persist flag (survives home->product nav) -> preselect ABO MENSUEL 63.- (message match pub) */
(function(){
  try{
    var p=new URLSearchParams(window.location.search);
    if(p.get('offer')==='onetime'||p.get('utm_source')==='meta'){
      try{ localStorage.setItem('nuho_meta_offer', String(Date.now())); }catch(e){}
    }
  }catch(e){}
  function metaFlag(){
    try{
      var p=new URLSearchParams(window.location.search);
      if(p.get('offer')==='onetime'||p.get('utm_source')==='meta') return true;
      var t=parseInt(localStorage.getItem('nuho_meta_offer')||'0',10);
      // flag valable 2h
      if(t && (Date.now()-t) < 7200000) return true;
    }catch(e){}
    return false;
  }
  function apply(){
    if(!metaFlag()) return false;
    var m=document.querySelector('.pdp__opt[data-opt="monthly"]');
    if(m && !m.classList.contains('pdp__opt--active')){ m.click(); return true; }
    return false;
  }
  window.addEventListener('load',apply);
  var n=0,iv=setInterval(function(){ n++; if(apply()||n>30) clearInterval(iv); },200);
})();
